<template>
  <div class="container page" style="background-color: #1f1c1f;">
    <van-nav-bar title="儲值記錄" class="nav-bar">
      <template #left>
        <img
          src="/img/newLogin/download.png"
          @click="back()"
          style="width: 20px; height: 15px;"
        />
      </template>
    </van-nav-bar>

    <div class="main">
      <van-pull-refresh v-model="isLoading" @refresh="onRefresh">
        <van-empty v-if="list.length === 0" description="資料為空" />

        <div v-else class="item_list" v-for="(v, key) in list" :key="key">
          <div class="lottery_info">
            <van-image class="cover" :src="v.ico">
              <template v-slot:loading>
                <van-loading type="spinner" />
              </template>
            </van-image>
            <span class="period-number">{{ v.expect }}</span>
            <span class="period-number">{{ v.name }}</span>
          </div>

          <div class="recent">
            <div class="kuaisan-ball left">
              <div>
                <span>認證結果</span>
                <!-- ✅ 每条记录自己的结果 -->
                <span class="ressquareBox">{{ v.size }}</span>
                <span class="ressquareBox">{{ v.double }}</span>
              </div>
            </div>
          </div>

          <div class="topInfo">
            <span v-if="v.status === 1" style="color: #07c160">{{ v.status_text }}</span>
            <span v-else>{{ v.status_text }}</span>
            <span>金額：{{ v.money }}</span>
          </div>

          <div class="time">
            <span>下單時間：{{ v.create_time }}</span>
          </div>
          <div class="time">
            <span>結算時間：{{ v.update_time }}</span>
          </div>
        </div>
      </van-pull-refresh>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      isLoading: false,
      list: [],
    };
  },
  methods: {
    back() {
      return window.history.back();
    },

    onRefresh() {
      // ✅ 下拉刷新：重新请求
      this.getUserGameList(true);
    },

    // ✅ 只保留繁体：火箭/飛機/遊艇/跑車
    calcResultFromOpenCode(opencode) {
      const a = Number(opencode && opencode[0] ? opencode[0] : 0);
      const b = Number(opencode && opencode[1] ? opencode[1] : 0);
      const c = Number(opencode && opencode[2] ? opencode[2] : 0);
      const sum = a + b + c;

      // 大小：11~18 火箭；3~10 飛機
      let size = "";
      if (sum >= 11 && sum <= 18) size = "火箭";
      else if (sum >= 3 && sum <= 10) size = "飛機";

      // 单双：保持你原本逻辑：偶数=跑車(two)，奇数=遊艇(one)
      let double = "";
      if (sum % 2 === 0) double = "跑車";
      else double = "遊艇";

      return { size, double };
    },

    getUserGameList(fromRefresh = false) {
      // ✅ 进入请求状态
      this.isLoading = true;

      this.$http({
        method: "get",
        url: "user_get_game_list",
      })
        .then((res) => {
          if (res.code === 200) {
            const raw = Array.isArray(res.data) ? res.data : [];
            const list = raw.map((item) => {
              const r = this.calcResultFromOpenCode(item.opencode);
              return {
                ...item,
                size: r.size,
                double: r.double,
              };
            });
            this.list = list;
          } else if (res.code === 401) {
            this.$toast(res.msg);
          }
        })
        .catch(() => {})
        .then(() => {
          if (fromRefresh) this.$toast("刷新成功");
          this.isLoading = false;
        });
    },
  },

  created() {
    if (!localStorage.getItem("token")) {
      this.$router.push({ path: "/Login" });
    } else {
      // ✅ 关键修复：必须调用接口（你原本注释掉了）
      this.getUserGameList(false);
    }
  },
};
</script>

<style lang="less" scoped>
@import "../../assets/css/base.css";

::v-deep .van-pull-refresh__track .van-pull-refresh__head * {
  color: #000000;
  font-size: 35px;
}

::v-deep .van-loading__text {
  color: #000000;
  font-size: 35px;
}

.container .main {
  position: relative;
  overflow: auto;
  background-color: #1f1c1f;
  height: 100%;
  padding: 0 10px;
}

.item_list {
  padding: 15px 15px;
  margin: 30px 10px;
  background: linear-gradient(120deg, #212121, #313131);
  border-radius: 10px;
  line-height: 60px;
  color: #f3c7a2;
  border: 1px solid #766350;
}

.item_list .topInfo span {
  flex: 1;
  font-size: 32px;
  font-weight: 700;
  color: #f3c7a2;
}

.item_list .time span {
  flex: 1;
  font-size: 25px;
  font-weight: 500;
  color: #f3c7a2;
}

.item_list .cover {
  width: 60px;
  height: 60px;
  object-fit: cover;
}

.item_list .period-number {
  margin-left: 50px;
  margin-right: 10px;
  height: 50px;
  line-height: 60px;
  font-size: 35px;
  font-weight: 700;
  color: #f3c7a2;
}

.item_list .lottery_info {
  display: flex;
}

.recent {
  display: flex;
  align-items: center;
  height: 100px;
}

.kuaisan-ball .left {
  justify-content: flex-start;
}

.kuaisan-ball {
  flex: 1;
  display: flex;
  align-items: center;
}

.ressquareBox {
  background: linear-gradient(#fde3ca, #e7b486);
  color: #333;
  height: 7vw;
  line-height: 7vw;
  text-align: center;
  font-size: 3vw;
  font-weight: 700;
  border-radius: 16px;
  margin-left: 20px;
  padding: 13px 40px;
  min-width: 13vw;
  white-space: nowrap;
}
</style>
